import type { RefObject } from "react";
import type { BackgroundMediaState } from "../hooks/useBackgroundMedia";

type BackgroundMediaProps = {
  readonly enabled: boolean;
  readonly videoRef: RefObject<HTMLVideoElement | null>;
  readonly state: BackgroundMediaState;
  readonly isMuted: boolean;
  readonly onReady: () => void;
  readonly onUnavailable: () => void;
};

export function BackgroundMedia({
  enabled,
  videoRef,
  state,
  isMuted,
  onReady,
  onUnavailable,
}: BackgroundMediaProps) {
  return (
    <div
      className="fixed inset-0 -z-10 overflow-hidden bg-[#10120e]"
      aria-hidden="true"
    >
      <div className="absolute inset-0 backdrop-fallback" />

      {enabled && state !== "unavailable" && (
        <video
          ref={videoRef}
          className={`motion-video absolute inset-0 z-10 size-full scale-[1.02] object-cover opacity-0 [filter:saturate(.68)_contrast(1.12)] transition-opacity duration-[1200ms] ${
            state === "ready" ? "opacity-[.68]" : ""
          }`}
          autoPlay
          muted={isMuted}
          loop
          playsInline
          preload="metadata"
          onCanPlay={onReady}
          onError={onUnavailable}
        >
          <source src="/media/background.mp4" type="video/mp4" />
        </video>
      )}

      <div className="absolute inset-0 z-20 backdrop-wash" />
      <div className="pointer-events-none absolute inset-0 z-30 film-grain opacity-[.17]" />
      <div className="absolute inset-0 z-40 technical-grid opacity-[.09]" />
    </div>
  );
}
